import * as THREE from 'three'

const authoredTransparency = new WeakMap<THREE.Material, boolean>()

export function rememberAuthoredTransparency(material: THREE.Material) {
  if (!authoredTransparency.has(material)) authoredTransparency.set(material, material.transparent)
}

export function setMaterialOpacity(material: THREE.Material, opacity: number) {
  const opaque = opacity >= 1
  const transparent = !opaque || (authoredTransparency.get(material) ?? false)
  material.opacity = opacity
  material.depthWrite = opaque
  if (material.transparent !== transparent) {
    material.transparent = transparent
    material.needsUpdate = true
  }
}
